const MODAL_BACKDROP_SELECTOR = ".modal-backdrop";
const OPEN_MODAL_SELECTOR = ".modal.show";

const restoreBootstrapStyle = (element, property) => {
  if (!element) return;

  const attributeName = `data-bs-${property}`;
  const initialValue = element.getAttribute(attributeName);

  if (initialValue === null) {
    element.style.removeProperty(property);
    return;
  }

  element.style.setProperty(property, initialValue);
  element.removeAttribute(attributeName);
};

export const getOpenModals = () => {
  if (typeof document === "undefined") return [];

  return Array.from(document.querySelectorAll(OPEN_MODAL_SELECTOR)).filter(
    (modal) => modal.style.display !== "none",
  );
};

export const cleanupModalArtifacts = ({ force = false } = {}) => {
  if (typeof document === "undefined") return false;
  if (!force && getOpenModals().length > 0) return false;

  document.querySelectorAll(MODAL_BACKDROP_SELECTOR).forEach((backdrop) => backdrop.remove());
  document.body.classList.remove("modal-open");

  restoreBootstrapStyle(document.body, "overflow");
  restoreBootstrapStyle(document.body, "padding-right");

  document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top").forEach((element) => {
    restoreBootstrapStyle(element, "padding-right");
  });

  document.querySelectorAll(".sticky-top").forEach((element) => {
    restoreBootstrapStyle(element, "margin-right");
  });

  return true;
};

export const scheduleModalCleanup = ({ force = false, delay = 50 } = {}) => {
  if (typeof window === "undefined") return null;

  return window.setTimeout(() => {
    cleanupModalArtifacts({ force });
  }, delay);
};

